import { useState } from "react";
import TextField from "@material-ui/core/TextField";
import { Tooltip, Grid, InputAdornment } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import { ToastMessage } from "../../../global/ToastMessage";
import { useDispatch, useSelector } from "react-redux";
import BackDrop from "../../../global/BackDrop";
import { useFormik } from "formik";
import * as yup from "yup";
import ControlledEditor from "../../../global/ControlledEditor";
import { 
  crearExtraVueloAction, 
  crearExtraVueloRegresoAction, 
  obtenerExtrasVueloAction, 
  obtenerExtrasVueloRegresoAction 
} from "../../../ducks/proveedorAereolineaDuck";
import { altaExtraAction } from "../../../ducks/extrasDuck";
import { catCiudad } from "../../../constant/catCiudad";
import HeaderModal from "../../../global/headerModal";

const validationSchema = yup.object({
  nombre: yup.string("Ingresa un nombre").required("Nombre es requerido"),
  suplemento: yup
    .number("Ingresa un suplemento válido")
    .required("Suplemento es requerido"),
    
});

const AltaExtraVuelo = ({ esRedondo, tipo }) => {
  const initialValues = {
    nombre: "",
    descripcion: "",
    suplemento: 0,
  }

  const dispatch = useDispatch();
  const origen = { IdCiudad: catCiudad.NO_APLICA };
  const { vueloTarget } = useSelector((store) => store.vueloProveedor);
  const [open, setOpen] = useState(false);
  const [isLoad, setIsLoad] = useState(false);
  const [descripcion, setDescripcion] = useState(
    "<p><strong>Escribe aquí tu texto</strong></p>"
  );

  const LimpiarForm = () => {
    formik.resetForm(initialValues);
    setDescripcion('<p><strong>Escribe aqui tu texto</strong></p>');
  };

  const handleClickOpen = () => {
    formik.resetForm();
    setOpen(true);
  }
  
  const handleClose = () => {
    setOpen(false);
    formik.resetForm();
    setDescripcion("<p><strong>Escribe aquí tu texto</strong></p>");
  };

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema,
    onSubmit: (values) => {
      setIsLoad(true);

      const payload = {
        Nombre: values.nombre,
        IdOrigen: origen.IdCiudad,
        Descripcion: descripcion,
      };

      dispatch(altaExtraAction(payload))
      .then((Response) => {
        switch (Response.status) {
          case 500:
            ToastMessage.fire({
              icon: "error",
              title: "Ha habido un problema de conexión con el servidor",
            });
            break
          case 400:
            ToastMessage.fire({
              icon: "warning",
              title: "<strong>Atención</strong>",
              text: "Al menos un dato no se ha enviado, favor de llenar el registro.",
            });
            break
          default: 
          LimpiarForm()
            const extra = {
              idVueloProveedor: vueloTarget?.IdVueloProveedor,
              idExtra: Response.data,
              suplemento: Number(values.suplemento),
              descripcion,
            };

            const extraRegreso = {
              idVueloRedondo: vueloTarget?.VueloRedondo?.IdVueloRedondo,
              idExtra: Response.data,
              suplemento: Number(values.suplemento),
              descripcion,
            }
            
            const dispatchAction = tipo === "regreso" 
              ? crearExtraVueloRegresoAction
              : crearExtraVueloAction;

            const extraData = tipo === "regreso" ? extraRegreso : extra;

            dispatch(dispatchAction(extraData)).then((respueta) => {
              switch (respueta?.status) {
                default:
                  setOpen(false);
                  setIsLoad(false);

                  if (tipo === "regreso") {
                    dispatch(obtenerExtrasVueloRegresoAction({ vuelo: vueloTarget?.VueloRedondo.IdVueloRedondo }));
                  } else {
                    dispatch(obtenerExtrasVueloAction({ vuelo: vueloTarget?.IdVueloProveedor }));
                  }

                  ToastMessage.fire({
                      icon: "success",
                      title: "Exito en la operacion",
                  });
                break
              }
            })
          break
        }
      })
    },
  });

  return (
    <div>
      <Tooltip title={`Agregar extra para vuelo ${esRedondo ? "regreso" : "ida"}`}>
        <Button
          variant="outlined"
          color="primary"
          onClick={handleClickOpen}
          startIcon={<AddCircleOutlineIcon />}
        >
          Nuevo extra
        </Button>
      </Tooltip>
      <Dialog open={open} onClose={handleClose} maxWidth="md">
        <form onSubmit={formik.handleSubmit}>
          <HeaderModal
            titulo={`Nuevo Extra - Vuelo ${esRedondo ? "regreso" : "ida"}`}
            handleClose={handleClose}
          />
          <DialogContent>
            <DialogContentText>
              {esRedondo 
                ? "Agregando extra al vuelo de regreso"
                : "Agregando extra al vuelo de ida"}
            </DialogContentText>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  required
                  label="Nombre"
                  variant="outlined"
                  name="nombre"
                  value={formik.values.nombre}
                  onChange={formik.handleChange}
                  error={formik.touched.nombre && Boolean(formik.errors.nombre)}
                  helperText={formik.touched.nombre && formik.errors.nombre}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  required
                  label="Suplemento"
                  variant="outlined"
                  name="suplemento"
                  type="number"
                  value={formik.values.suplemento}
                  onChange={formik.handleChange}
                  error={
                    formik.touched.suplemento && Boolean(formik.errors.suplemento)
                  }
                  helperText={
                    formik.touched.suplemento && formik.errors.suplemento
                  }
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">{vueloTarget?.Moneda?.Clave}</InputAdornment>
                    ),
                  }}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12}>
                <ControlledEditor
                  content={descripcion}
                  onValue={(value) => setDescripcion(value)}
                  height="150px"
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions style={{padding: "1rem", paddingRight: "1.5rem"}}>
            <Button onClick={handleClose} color="secondary" variant="contained">
              Cancelar
            </Button>
            <Button type="submit" color="primary" variant="contained">
              Agregar
            </Button>
          </DialogActions>
        </form>
      </Dialog>
      <BackDrop open={isLoad} />
    </div>
  );
};

export default AltaExtraVuelo;
